//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        requisites: '',
        dateCreatedFrom: '',
        dateCreatedTo: '',
        dateDeletedFrom: '',
        dateDeletedTo: '',
      },
    };
  },

  computed: {
    ...mapState('userP2PRequisites', ['filterLists', 'paymentMethods']),
    ...mapGetters('userP2PRequisites', ['paymentMethodsList']),

    listMethods: {
      get() {
        return this.paymentMethods;
      },
      set(data) {
        this.setPaymentMethodsFilter(data);
      },
    },
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('userP2PRequisites', ['setFilters', 'setPaymentMethodsFilter']),
  },
};
